<script setup lang="ts">
import KTextField from '@/components/fields/KTextField.vue';
</script>

<template>
  <KTextField
    size="lg"
    label="Email or username"
    name="username"
    email
    data-testid="emailOrUsernameField"
  />
</template>
